import { render, staticRenderFns } from "./wxPay.vue?vue&type=template&id=48324432&scoped=true"
import script from "./wxPay.vue?vue&type=script&lang=js"
export * from "./wxPay.vue?vue&type=script&lang=js"
import style0 from "./wxPay.vue?vue&type=style&index=0&id=48324432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48324432",
  null
  
)

export default component.exports